import { render, staticRenderFns } from "./TplItem.vue?vue&type=template&id=2ceeb2c4&"
import script from "./TplItem.vue?vue&type=script&lang=js&"
export * from "./TplItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports